import React, { useState } from 'react';
import { Crown, X, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TrialBanner = () => {
  const { trialActive, trialDaysLeft, getToken } = useAuth();
  const [dismissed, setDismissed] = useState(sessionStorage.getItem('trial_banner_dismissed') === '1');
  const [loading, setLoading] = useState(false);

  if (!trialActive || dismissed) return null;

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/payment/create-checkout-session`,
        { origin_url: window.location.origin },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      if (res.data.url) window.location.href = res.data.url;
    } catch (err) {
      console.error('Checkout error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem('trial_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      data-testid="trial-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-2.5 rounded-full border border-[#C5A059]/40 bg-[#0B0D12]/95 backdrop-blur-xl shadow-lg shadow-[#C5A059]/10"
    >
      <div className="w-7 h-7 rounded-full bg-gradient-to-br from-[#C5A059] to-[#D4AF37] flex items-center justify-center flex-shrink-0">
        <Crown size={14} className="text-black" />
      </div>
      <span className="text-sm text-white whitespace-nowrap" data-testid="trial-days-left">
        <span className="font-semibold text-[#C5A059]">Pro Trial</span>
        <span className="text-gray-400"> — {trialDaysLeft} {trialDaysLeft === 1 ? 'day' : 'days'} left</span>
      </span>
      <button
        data-testid="trial-upgrade-btn"
        onClick={handleUpgrade}
        disabled={loading}
        className="text-xs font-semibold px-3 py-1.5 rounded-full bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black hover:opacity-90 transition-opacity flex items-center gap-1.5"
      >
        {loading ? <Loader2 size={12} className="animate-spin" /> : 'Upgrade $10/mo'}
      </button>
      <button
        data-testid="trial-banner-dismiss"
        onClick={handleDismiss}
        className="text-gray-500 hover:text-white transition-colors"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default TrialBanner;
